export const formatStatus = (status: string | null | undefined): string => {
  const statusMap: Record<string, string> = {
    PRE_RESERVA: "Pré Reserva",
    AGUARDANDO_HOSPEDES: "Aguardando Hóspedes",
    AGUARDANDO_AUTORIZACAO: "Aguardando Autorização",
    AGUARDANDO_CHECKIN: "Aguardando CheckIn",
    FINALIZADO: "Finalizado",
    AGUARDANDO_CADASTRO: "Aguardando Cadastro",
    AGUARDANDO_APTO: "Aguardando Apto",
    AGUARDANDO_APTOMAISINFO: "Aguardando Mais Informações do Apto",
    AGUARDANDO_TITULARIDADE: "Aguardando Titularidade",
    AGUARDANDO_REPRESENTANTE: "Aguardando Representante",
    AGUARDANDO_COMPROVANTE: "Aguardando Comprovante",
    AGUARDANDO_COTA: "Aguardando Cota",
    AGUARDANDO_PERIODOS: "Aguardando Períodos",
    AGUARDANDO_DEFINICAO_PERIODOS: "Aguardando Definição de Períodos",
    AGUARDANDO_DEFINICAO_ANUNCIO: "Aguardando Definição do Anúncio",
    AGUARDANDO_MAISINFO_ANUNCIO: "Aguardando Mais Informações do Anúncio",
    AGUARDANDO_PAGAMENTO: "Aguardando Pagamento",
    AGUARDANDO_AUTENTICACAO: "Aguardando Autenticação",
    AGUARDANDO_PROCURACAO: "Aguardando Procuração",
    AUTENTICADA_NIVEL1: "Autenticada - Nível 1",
    AUTENTICADA_NIVEL2: "Autenticada - Nível 2",
    VENDENDO: "Vendendo",
    CANCELADA: "Cancelada",
    VENDIDA_MC: "Vendida via MC",
    VENDIDA_PROPRIO: "Vendida pelo Próprio",
    AGUARDANDO_PAGAMENTO_PROPRIETARIO: "Aguardando Pagamento Proprietário",
    CONFIRMAR_RESERVA: "Confirmar Reserva",
    AGUARDANDO_PAGAMENTO_MC: "Aguardando Pagamento MC",
    ESCRITURADO: "Escriturado",
    QUITADO: "Quitado",
    NAO_QUITADO: "Não Quitado",
    NA_PLANTA: "Na Planta",
  };

  return status
    ? statusMap[status] || "Status desconhecido"
    : "Status não disponível";
};
